<template>
  <div class="upload">
    <el-input v-model="val" placeholder="" style="display: none;" ></el-input>
    <input ref="input" style="display: none;" type="file" @change="upFIle">
    <div class="upchild">
        <span >{{ tabel }}</span>
       
        <span>
            <!-- <i v-if="flag === 0"  @click="upload" class="el-icon-upload"></i> -->
            <el-button  v-if="flag === 0"  @click="upload" type="warning">上传<i class="el-icon-upload el-icon--right"></i></el-button>
            <i v-if="flag === 1"  class="el-icon-loading"></i>
            <el-button  :disabled="disabled" v-if="flag === 2" type="info" icon="el-icon-edit" @click="upload">修改</el-button>
            <el-button  v-if="flag === 2" type="success" icon="el-icon-view" @click="setShow">查看</el-button>
        </span>
    </div>
    <!-- <img src="https://lcappbucket.oss-cn-shanghai.aliyuncs.com/准入管理/浙银数科/logo_20230614_1686723807051.png" alt=""> -->
    <wPreview  :url="val" ref="wview"></wPreview>
  </div>
</template>

<script>
import wPreview from '@/components/w-preview/index.vue'
export default {
    props: ['value','tabel','disabled'],
    data(){
        return {
            val: this.value,
            flag: 0,
            isShow: false,
           
        }
    },
    
    watch: {
        value: {
            handler(val){
                console.log(val,'val111')
                console.log(val,val)
                this.val = val
                if(val){
                    console.log(val,'ture')
                    this.$nextTick(() =>{
                        this.flag = 2
                        console.log(this.flag,'true')
                    })
                }else{
                    this.$nextTick(() =>{
                        this.flag = 0
                        console.log(this.flag,'false')
                    })
                   
                   
                }
            
            },
            immediate: true,
        }
    
    },
    mounted(){
        // this.init()
    },
    methods: {
        // init(){
        //     console.log(this.value,'this.value')
        //     if(this.value){
        //             this.flag = 2
        //         }
        // },
        setShow(){
            this.$nextTick(()=>{
                this.$refs.wview.init(this.val)
            })
            
           
        },
        upload(){
            this.$refs.input.click()
        },
        upFIle(e){
        this.flag = 1
        let fd = new FormData()
        fd.append('file',e.target.files[0])
        // fd.append('cancelToken',Cookies.get('token'))
        this.$http.post('/sys/accessmanagement/saveFile',fd).then(({data: res})=> {
            if(res.code !== 0){
                this.flag = 0
                this.$message.error(res.msg)
                return 
            }
            this.flag = 2
            // this.$message.success(res.msg)
            this.val = res.data
            this.$emit('input',res.data)
            console.log(res.data)
        })
        
      }
      
    },
    components:{
        wPreview,
    }


}
</script>

<style lang="scss" scoped>
.upload{
    display: flex;
    width: 100%;
    padding-right: 20px ;
    .upchild{
        display: flex;
        width: 100%;
        justify-content: space-between;
        & span:nth-child(2){
            display: flex;
            text-align: center;
          
        }
       
    }
}
::v-deep .el-button {
    height: 40px;
}
.el-icon-loading{
    
    width: 14px;
    height: 14px;
}

</style>